<template>
  <div class="hp-base-panel-wrp">
    <div class="interview-panel hp-base-panel">
      <div class="hp-title">
        <em class="left">访谈</em>
      </div>
      <ul class="inter-list">
        <li
          class="inter-item"
          v-for="(item, index) in interviewList"
          :key="index"
        >
          <div class="inter-t">
            <img
              class="inter-img fl"
              src="~images/platform/homepage/inter-q.png"
              alt=""
            />
            <p>{{ item.question }}</p>
          </div>
          <div class="inter-b">
            <yxlMore :lineClamp="3" :info="genInfo(item)" />
            <!-- <img
              class="inter-img im"
              src="~images/platform/homepage/inter-a.png"
              alt=""
            />
            <div class="text" v-html="genInfo(item)"></div> -->
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import yxlMore from 'component/common/yxlMore.vue'
export default {
  components: {
    yxlMore
  },
  computed: {
    interviewList() {
      return this.$store.getters['homepage/interviewList']
    }
  },
  methods: {
    genInfo(item) {
      return (
        `<img class="inter-img im" src="${require('images/platform/homepage/inter-a.png')}" alt=""/>` +
        item.answer.replace(/\n/g, '</br>')
      )
      // return item.answer.replace(/\n/g, '</br>')
    },

    setShowAllCallback(showall) {
      // 展开全部埋点
      if (showall) {
        this.$trackEvent('newprofilepages_interview_all', {})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.interview-panel {
  /deep/ .yxl-more {
    .content {
      white-space: pre-wrap !important;
    }
  }

  .inter-item {
    padding: 32px 0;
    border-bottom: 1px solid #eaeaea;
    &:last-child {
      border-bottom: none;
      padding-bottom: 0;
    }
    &:first-child {
      padding-top: 0;
    }
  }
  /deep/ .inter-img {
    width: 38px;
    height: 38px;
    object-fit: cover;
    margin-right: 10px;
  }
  /deep/ .im {
    display: inline;
    vertical-align: middle;
  }
  .fl {
    float: left;
  }
  .inter-t {
    display: flex;
    justify-content: flex-start;
    p {
      font-size: 30px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #21252d;
    }
  }
  .inter-b {
    display: flex;
    justify-content: flex-start;
    margin-top: 16px;
    font-size: 26px;
    color: #6c798c;
    // .text {
    //   font-size: 26px;
    //   line-height: 45px;
    //   color: #6c798c;
    //   white-space: normal;
    //   word-break: break-all;
    // }
  }
}
</style>
